
import Vue from 'vue';
import Component from 'vue-class-component';
import { Watch, Prop } from 'vue-property-decorator';
import { db } from '@/plugins/firebase';
import { Entry, Project, Collection } from '@/types';
import MarkdownIt from 'markdown-it';
const md = new MarkdownIt();

@Component({
  firestore: {
    progresses: db
      .collection('dailyProgress')
      .orderBy('timestamp', 'desc')
      .limit(1),
  },
})
export default class ProjectIndex extends Vue {
  @Prop(Object) project: Project;
  @Prop(Array) collections: Collection[];
  progresses = [];

  get latestProgress() {
    return this.progresses &&
      this.progresses[0] &&
      this.progresses[0].projects[this.project.id]
      ? this.progresses[0].projects[this.project.id]
      : null;
  }

  detail(): string {
    if (this.project && this.project.markdown) {
      return md.render(this.project.markdown);
    } else {
      return '';
    }
  }

  created() {
    //console.log(this.project);
  }
}
